import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./Css/View.css";
import API_BASE from "../config/api";

const StudentProfile = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_BASE}/api/instituteadmin/students/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("Student API Response:", res.data); 
        setStudent(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [id, token]);

  useEffect(() => {
    if (student) {
      console.log("Student State:", student);
    }
  }, [student]);

  if (loading) return <p>Loading...</p>;
  if (!student) return <p>Student not found</p>;

const backendUrl = window.location.hostname === "localhost" 
  ? `${API_BASE}`// dev backend
  : `${API_BASE}`; // production backend

const profileUrl = student.profilePictureUrl
  ? `${backendUrl}${student.profilePictureUrl}`
  : `${window.location.origin}/default-profile.png`; // default image in public folder

  return (
    <div className="student-page">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          विद्यार्थी व्यवस्थापन &gt;&gt; <span>विद्यार्थी तपशील</span>
        </h3>

        <button
          className="edit-btn"
          onClick={() => navigate(`/dashboard/studentedit/${id}`)}
        >
          एडिट करा
        </button>
      </div>

      <h2>विद्यार्थी तपशील</h2>

      <div className="profile-card">
      <img
  src={profileUrl}
  alt="student"
  className="profile-img"
/>
 <p className="updated-text">
          Last Updated{" "}
          {student.createdAt
            ? new Date(student.createdAt).toLocaleDateString()
            : "-"}
        </p>
      </div>
      <div className="info-grid">
        <div className="info-box">
          <label>विद्यार्थ्याचे नाव</label>
          <p>{student.studentName || "-"}</p>
        </div>

        <div className="info-box">
          <label>विद्यार्थी ID</label>
          <p>{student.studentUniqueId || "-"}</p>
        </div>

        <div className="info-box">
          <label>इयत्ता</label>
          <p>{student.standardName || "-"}</p>
        </div>

        <div className="info-box">
          <label>पालकांचा संपर्क क्रमांक</label>
          <p>{student.parentPhoneNumber || "-"}</p>
        </div>

        <div className="info-box">
          <label>पत्ता</label>
          <p>{student.address || "-"}</p>
        </div>

        <div className="info-box">
          <label>ईमेल</label>
          <p>{student.email || "-"}</p>
        </div>

        <div className="info-box">
          <label>जन्मतारीख</label>
          <p>
            {student.birthDate
              ? new Date(student.birthDate).toLocaleDateString("en-IN")
              : "-"}
          </p>
        </div>

        <div className="info-box">
          <label>पालकांचे नाव</label>
          <p>{student.fatherName || "-"}</p>
        </div>

        <div className="info-box">
          <label>परीक्षेचे नाव</label>
          <p>
            {student.softwares && student.softwares.length > 0
              ? student.softwares.map((s) => s.softwareName).join(", ")
              : "-"}
          </p>
        </div>
        
      </div>
       <div className="exam-section">
        <h2>परीक्षा निकालांचा आढावा</h2>

        <table>
          <thead>
            <tr>
              <th>क्र.</th>
              <th>परीक्षा नाव</th>
              <th>विषय</th>
              <th>एकूण गुण</th>
              <th>मिळालेले गुण</th>
              <th>निकाल</th>
              <th>तारीख</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>१</td>
              <td>पूर्व उ. मा. शिष्यवृत्ती परीक्षा</td>
              <td>मराठी</td>
              <td>२५</td>
              <td>२४</td>
              <td className="pass">पास</td>
              <td>२० ऑगस्ट २०२४</td>
            </tr>

            <tr>
              <td>२</td>
              <td>ज. नवोदय विद्यालय प्रवेश परीक्षा</td>
              <td>इंग्रजी</td>
              <td>२५</td>
              <td>२३</td>
              <td className="pass">पास</td>
              <td>२० जून २०२४</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StudentProfile;
